import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppRoutes as app, AuthRoutes as auth, RootRoutes as root } from '@app/shared/routes/routes';

import { Error404Component } from '@app/shared/containers/error404/error404.component';

const appRoutes = [
  {path: auth.root.path, loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)},
  {path: app.root.path, loadChildren: () => import('./modules/core/core.module').then(m => m.CoreModule)},
  {path: root.Error404.path, component: Error404Component},
  {path: '', redirectTo: auth.Login.path, pathMatch: 'full'},
  {path: '**', redirectTo: root.Error404.path, pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
